import { UPDATE_SEARCHTDATA_LICHSU_BANK } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank/actionTypes";
import {currentDate } from "utils/formatDate";

const initialState = {
  sSoTaiKhoan:"",
  TuNgay : currentDate(),
  DenNgay: currentDate(),
  iPageIndex: 1,
  iPageSize: 25,
};
const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchLichSuBankReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_LICHSU_BANK:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchLichSuBankReducer;
